.root {
  position: sticky;
  top: 0;
  z-index: var(--z-menus);
  display: flex;
  gap: 0.5rem;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 1rem;
  background: white;
}

.language {
  position: relative;
  top: 2px;

  a {
    font-size: 0.875rem;
  }
}

.pushRight {
  margin-left: auto;
}

.hideInPrint {
  @media print {
    display: none;
  }
}

.desktopOnly {
  @media (--md-down) {
    display: none;
  }
}
